"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PromptChip = require("./PromptChip");
Object.keys(_PromptChip).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PromptChip[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PromptChip[key];
    }
  });
});